import { Link } from "react-router-dom";

// Distinctive "IntoLaw" wordmark. The oversized serif "L" in champagne gold
// is the memorable architectural feature of the brand.
export const LogoMark = ({ className = "h-9 w-9" }) => (
  <span
    className={`inline-flex items-center justify-center rounded-xl bg-navy ${className}`}
    aria-hidden="true"
  >
    <span className="font-display font-semibold text-gold leading-none" style={{ fontSize: "1.4em" }}>
      L
    </span>
  </span>
);

export const Wordmark = ({ variant = "dark", className = "" }) => {
  // variant "dark" -> for light backgrounds; "light" -> for dark backgrounds
  const intoColor = variant === "dark" ? "text-navy" : "text-white";
  const awColor = variant === "dark" ? "text-royal" : "text-royal";
  return (
    <span className={`font-body font-bold tracking-tight leading-none ${className}`}>
      <span className={intoColor}>Into</span>
      <span className="font-display font-semibold text-gold relative" style={{ fontSize: "1.18em", lineHeight: 0 }}>
        L
      </span>
      <span className={awColor} style={{ marginLeft: "-0.04em" }}>aw</span>
    </span>
  );
};

const Logo = ({ variant = "dark", showMark = false, className = "", textClass = "text-2xl", onClick }) => (
  <Link
    to="/"
    onClick={onClick}
    aria-label="IntoLaw home"
    data-testid="logo-link"
    className={`inline-flex items-center gap-2.5 ${className}`}
  >
    {showMark && <LogoMark />}
    <Wordmark variant={variant} className={textClass} />
  </Link>
);

export default Logo;
